import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { initListChecked } from '../listCompany/helper'
import { getSearchPortfolio, postCreatePortfolio } from './thunk'

const initialState = {
  listChecked: {},
  idsOfCurrentPage: [],
  validateNameCreatePortfolio: '',
  dataRawTableSavedPortfolio: [],
  isLoadingDataRaw: true,
  currentPortfolio: { name: '', id: undefined },
}

const slice = createSlice({
  name: 'portfolioInsights/popupCompanyList',
  initialState,
  reducers: {
    createListChecked: (state, action) => {
      state.listChecked = initListChecked(state.listChecked, action.payload)
    },
    createIdsOfCurrentPage: (state, action) => {
      state.idsOfCurrentPage = action.payload
    },
    changeListCheckedById: (state, action) => {
      const key = action.payload
      state.listChecked[key] = !state.listChecked[key]
    },
    changeListCheckedByArrId: (state, action) => {
      const { keys, checkedState } = action.payload
      keys.forEach((key) => {
        state.listChecked[key] = checkedState
      })
    },
    resetStore: (state) => {
      Object.keys(initialState).forEach((key) => {
        if (key === 'currentPortfolio') return
        state[key] = initialState[key]
      })
    },
    clearValidateNameCreatePortfolio: (state) => {
      state.validateNameCreatePortfolio = ''
    },
    changeCurrentPortfolio: (state, action) => {
      state.currentPortfolio = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postCreatePortfolio.rejected, (state, action) => {
      state.validateNameCreatePortfolio = action.payload.message
    })
    builder.addCase(getSearchPortfolio.pending, (state) => {
      state.isLoadingDataRaw = true
    })
    builder.addCase(getSearchPortfolio.fulfilled, (state, action) => {
      state.dataRawTableSavedPortfolio = action.payload.data
      state.isLoadingDataRaw = false
    })
    builder.addCase(getSearchPortfolio.rejected, (state) => {
      state.dataRawTableSavedPortfolio = []
      state.isLoadingDataRaw = false
    })
  },
})

export const {
  createListChecked,
  changeListCheckedById,
  changeListCheckedByArrId,
  resetStore,
  createIdsOfCurrentPage,
  clearValidateNameCreatePortfolio,
  changeCurrentPortfolio,
} = slice.actions

export const selectListChecked = (state) => state[slice.name].listChecked
export const selectIdsOfCurrentPage = (state) =>
  state[slice.name].idsOfCurrentPage
export const selectIsCheckedById = (id) => (state) =>
  state[slice.name].listChecked[id]
export const selectTextValidateNamePortfolio = (state) =>
  state[slice.name].validateNameCreatePortfolio
export const selectDataRawTable = (state) =>
  state[slice.name].dataRawTableSavedPortfolio
export const selectLoadingDataRawPortfolio = (state) =>
  state[slice.name].isLoadingDataRaw
export const selectCurrentPortfolio = (state) =>
  state[slice.name].currentPortfolio

register(slice.name, slice.reducer)
